export default "https://cdn.questicon.mathletics.com/assets/images/Grimacing Face-66d48edcbfd98abcda53fee3c7f2ac61.svg";